import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Userpilot } from 'userpilot'
import useMediaQuery from '@/hooks/use-media-query'
import { Heading, ParagraphRegular } from '@/components/text'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Stack, Box } from '@/components/structure'
import { WarningBanner } from '@/components/banner'
import { breakpoints, colors } from '@/styles'
import ENV_VARS from '@/config'

const { WEB_URL } = ENV_VARS

const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  button,
  a {
    flex: 1;
  }
`

const UserLimitReached: React.FC<Nothing> = () => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const padding = 24
  const handlePricingClick = () => {
    Userpilot.track('app_upgrade_comanagement_usermodal_upgrademyplan_btn')
    window.open(`${WEB_URL}/pricing`)
  }
  return (
    <>
      <WarningBanner />
      <Box ptop={padding} pbottom={padding} pleft={padding} pright={padding}>
        <Stack gutter="32px">
          <Stack gutter="8px" textAlign="center">
            <Heading type={!displayMobile ? 'h4' : 'h5'}>
              {t('l.plans.edit.user_limit_reached.heading', 'User Limit Reached')}
            </Heading>
            <Stack color={colors.grey56} gutter="24px">
              <ParagraphRegular>
                {t(
                  'l.plans.edit.user_limit_reached.text',
                  'You have exceeded the number of users allowed for your current plan.  All of your current users will stay active, but you will not be able to add more users.'
                )}
              </ParagraphRegular>
              <ParagraphRegular>
                {t(
                  'l.plans.edit.user_limit_reached_upgrade.text',
                  "If you'd like to add more users, you can upgrade your plan to one that better matches your current needs."
                )}
              </ParagraphRegular>
            </Stack>
          </Stack>
          <ButtonWrapper>
            <Button theme="secondary" onClick={close}>
              {t('common.cancel', 'Cancel')}
            </Button>
            <Button onClick={handlePricingClick}>
              {t('l.plans.edit.user_limit.button', 'Upgrade My Plan')}
            </Button>
          </ButtonWrapper>
        </Stack>
      </Box>
    </>
  )
}

const show = createModal(UserLimitReached, { width: '492px', showClose: false })

export default show
